import { useIsFocused } from "@react-navigation/native"

/**
 * Custom hook that safely checks if the screen is focused
 * Returns true if not in a navigation context (e.g., when component is used in a modal)
 * @returns {boolean} Whether the screen is focused or true if not in navigation context
 */
export const useIsFocusedM = () => {
    let isFocused = true
    try {
        isFocused = useIsFocused()
    } catch (e) {
        // Not in navigation context, assume always focused
        isFocused = true
    }
    return isFocused
}
